module.exports = __webpack_public_path__ + "static/media/ancho.a4fc5dbd.png";